import { Component, Input, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  standalone: false,
    selector: 'kt-weight-modal-alert',
    templateUrl: './weight-modal-alert.component.html',
    styleUrls: ['./weight-modal-alert.component.scss']
})
/**
 * Class that define the behavior of the modal-alert component
 * @author Castor Transformación Digital - Alvaro Felipe Garcia Mendez
 * @since 2019-12-2
 */
export class WeightModalAlertComponent implements OnInit {
    /**
     * Receives the coming data (base64 string) to set the pdf
     */
    @Input() data: any;
	/**
     * Receives the coming data (base64 string) to set the pdf
     */
    @Input() errorMessage: boolean;
    /**
     * Shows error flag
     */
    @Input() hasError: boolean = false;

	@Input() hasWarning: boolean = false;

    @Input() showClose: boolean = true;
    
    @Input() labelButton: string = 'Close';
    
    @Input() showCancel: boolean = false;


    constructor(
        private dialogRef: MatDialogRef<any>,
    ) { }

    ngOnInit() {
    }

    /**
     * Closes the actual modal
     * @author Castor Transformación Digital - Alvaro Felipe Garcia Mendez
     * @since 2019-12-4
     */
    public close(cancel?: boolean) {
        (cancel) ? this.dialogRef.close(cancel) : this.dialogRef.close();
    }

}
